<!--分路段限速提醒，新增和修改线路-->

<template>
  <el-dialog
    :title="title"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    destroy-on-close
    fullscreen
    width="80%"
  >
    <div style="padding: 20px">
      <el-row>
        <el-col :span="6">
          <div style="text-align: left; margin-right: 16px">
            <div>{{$t('arealimitset.lineinfo')}}</div>
            <div>
              <el-form :model="form" :size="size" label-width="120px">
                <el-form-item :label="$t('arealimitset.linename')">
                  <el-input
                    v-model="form.routeName"
                    :placeholder="$t('arealimitset.inputlinename')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('arealimitset.drawline')">
                  <el-button @click="drawArea" type="primary">{{
                    drawing ? $t('arealimitset.canceldrawline') : $t('arealimitset.clickdrawline')
                  }}</el-button>
                </el-form-item>
                <el-form-item label="">
                  <span
                    style="margin-left: 6px; color: #a2b1cb; font-size: 12px"
                    >{{$t('arealimitset.opeinmap')}}</span
                  >
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSaveClick" :size="size"
                    >{{$t('public.save')}}</el-button
                  >
                  <el-button @click="dialogVisible = false" :size="size"
                    >{{$t('public.cancel')}}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>

        <el-col :span="18" style="height: calc(100vh - 100px)">
          <KingLongMap
            ref="map"
            mapId="content_remind_line"
            @LoadCompleted="mapLoadCompleted"
            @DrawPolyLineCompleted="DrawPolyLineCompleted"
          />
        </el-col>
      </el-row>
      <div></div>
    </div>
  </el-dialog>
</template>
<script>
import KingLongMap from "@/components/KingLongMap.vue";
export default {
  components: { KingLongMap },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },
  data() {
    return {
      title:this.$t('arealimitset.addline'),
      dialogVisible: false,
      form: {
        routeId: -1,
        routeName: "",
        lonlats: "",
        cutlonlats:"",
      },
      mapLoaded: false,
      drawing: false,
    };
  },
  methods: {
    onSaveClick() {
      //提交线路保存
      //判断线路名称是否填写
      if (this.form.routeName == "") {
        this.$message({
          message:this.$t('arealimitset.plsinputlinename'),
          type: "warning",
        });
        return;
      }
      //判断线路是否规划
      if (this.form.lonlats == "") {
        this.$message({
          message:this.$t('arealimitset.plsdrawline'),
          type: "warning",
        });
        return;
      }
      //保存线路信息
      this.$api
        .saveLimitRouteInfo({
          routeId: this.form.routeId||-1,
          routeName: this.form.routeName,
          lonlats: this.form.lonlats,
          CompanyID: this.operator.CompanyId,
          OperatorID: this.operator.OperatorId,
        })
        .then((res) => {
       
          this.$message.success(this.$t('public.hasSaved'));
          this.$emit("ok");
          this.dialogVisible = false;
        })
        .catch((err) => {
          //提示保存失败
          this.$message({
            message: this.$t('public.SaveFail') ,
            type: "warning",
          });
        });
    },
    add() {
      this.edit({});
      // this.form.routeId = -1;
      // this.form.routeName = "";
      // this.form.lonlats = "";
      // this.form.cutlonlats = "";
      this.title = this.$t('arealimitset.addline');
    },
    edit(row) {
      this.form = Object.assign({}, row);
      this.title =this.$t('arealimitset.editline');

      this.dialogVisible = true;
      if (this.mapLoaded) {
        this.$nextTick(() => {
          this.showArea();
        });
      }
    },
    showArea() {
      this.$refs.map.clearAll();
      
      if (this.form && this.form.lonlats) {
        var circleInfo = this.form.lonlats.split(";");

        var coordanites = [];
        circleInfo.forEach((element) => {
          var p = element.split(",");
          coordanites.push({
            lng: parseFloat(p[0]),
            lat: parseFloat(p[1]),
          });
        });

        this.$refs.map.addPolyline(
          "AREA1",
          this.form.routeName,
          coordanites,
          5,
          0xcd3700
        );
      }
    },
    drawArea() {
      //画区域
      if (this.drawing) {
        //正在画，取消画
        this.$refs.map.cancelDraw();
        this.drawing = false;
      } else {
        //根据选中类型进行

        this.$refs.map.drawLine();

        this.drawing = true;
      }
    },
    DrawPolyLineCompleted(lnglats) {
      this.drawing = false;
      this.form.lonlats = lnglats;
    },

    mapLoadCompleted() {
      if (!this.mapLoaded) {
        this.mapLoaded = true;
        this.$nextTick(() => {
          this.showArea();
        });
      }
    },
  },
};
</script>
<style></style>
